
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z","fill":"#A9B1BD"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.186 10.545c.044.914-.336 1.04-.476 1.087l-.006.002h-.001c-.127.037-.519.148-1.016-.634C7.4 5.812 7.312 5.66 7.312 5.66a.585.585 0 01.17-.553c.49-.509 3.16-1.259 3.856-1.08.224.053.384.196.438.402.035.223.357 5.035.41 6.116zm-1.375 2.99c-.018.313-.196.545-.464.626l-1.071.348c-2.402.768-2.482.785-2.607.785a.582.582 0 01-.483-.32c-.071-.144-.125-.385-.151-.67-.099-.876.018-2.188.276-2.599.125-.196.304-.294.5-.285.114 0 .208.038 1.805.689l.003.001 1.023.417s-.01.009.75.303c.268.107.437.384.42.706zm1.33 2.242v1.187c-.008 2.466-.009 2.555-.053 2.67-.071.187-.232.312-.455.357-.643.107-2.652-.634-3.072-1.134a.628.628 0 01-.151-.322.508.508 0 01.035-.232c.045-.125.125-.223 1.92-2.348 0 0 .009 0 .536-.625.178-.223.5-.294.794-.187.295.116.456.366.447.634zm4.019 2.982c.607-.241 1.937-1.929 2.026-2.572.036-.232-.035-.42-.196-.544-.098-.08-.179-.107-2.58-.893-1.054-.348-1.063-.357-1.063-.357-.259-.09-.544-.01-.74.232-.206.25-.233.571-.072.821l.42.688c1.428 2.321 1.535 2.482 1.642 2.562.152.125.357.143.563.063zm1.705-6.723c.17-.116.25-.304.232-.527v-.027c-.072-.67-1.241-2.41-1.822-2.687-.205-.099-.41-.099-.58.017-.106.071-.177.168-1.605 2.119l-.038.051c-.66.902-.67.91-.67.91-.16.215-.169.51 0 .777.17.268.474.393.742.322l-.01.018c.135-.045.376-.107.813-.206 2.724-.66 2.83-.696 2.938-.767z","fill":"#fff"}})])
          )
        }
      }
    